import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgArrowDownEnd = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={26}
    height={25}
    viewBox='0 0 26 25'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M14.8536 21.3534C15.0488 21.1582 15.0488 20.8416 14.8536 20.6463L11.6716 17.4643C11.4763 17.2691 11.1597 17.2691 10.9645 17.4643C10.7692 17.6596 10.7692 17.9762 10.9645 18.1715L13.7929 20.9999L10.9645 23.8283C10.7692 24.0236 10.7692 24.3402 10.9645 24.5354C11.1597 24.7307 11.4763 24.7307 11.6716 24.5354L14.8536 21.3534ZM26 0.499878H7V1.49988H26V0.499878ZM0.5 6.99988V14.9999H1.5V6.99988H0.5ZM7 21.4999H14.5V20.4999H7V21.4999ZM0.5 14.9999C0.5 18.5897 3.41015 21.4999 7 21.4999V20.4999C3.96243 20.4999 1.5 18.0374 1.5 14.9999H0.5ZM7 0.499878C3.41015 0.499878 0.5 3.41003 0.5 6.99988H1.5C1.5 3.96231 3.96243 1.49988 7 1.49988V0.499878Z'
      fill='#93949A'
    />
  </svg>
);
export default SvgArrowDownEnd;
